const assist = (parameter = {}, page = 1) => {
  if (parameter.page) parameter.page = page;
  if (parameter.regDate && !parameter.regDate.includes('~')) {
    parameter.startDate = parameter.regDate;
    parameter.endDate = parameter.regDate;
  }
  if (parameter.regDate && parameter.regDate.includes('~')) {
    parameter.startDate = parameter.regDate.split('~')[0].trim();
    parameter.endDate = parameter.regDate.split('~')[1].trim();
  }

  return parameter;
};

export default { assist };
